<div class="manual-verify-container">
  <div class="manual-verify-container__header">
    <div class="manual-verify-container__header-title">Are you sure?</div>
    <div class="close-icon">
      <img alt="" (click)="onCancel()" src="assets/icons/x-delivery-services.svg" />
    </div>
  </div>
  <div class="manual-verify-container__text">
    <div class="manual-verify-container__text__content">
      Bulk approving '{{selectedOption?.label}}' will apply to all selected orders.
    </div>
  </div>

  <div class="manual-verify-container__actions">
    <pdq-button class="manual-verify-container__actions-cancel" (onClick)="onCancel()" label="Cancel" variant="light">
    </pdq-button>

    <pdq-button
      class="manual-verify-container__actions-apply"
      label="Apply"
      [loading]="isOrdersVerified"
      (onClick)="verifyOrders()"
      variant="primary">
    </pdq-button>
  </div>
</div>
